class TaystBundleWidget {
  constructor() {
    this.submitBtn = document.querySelector(".tayst-bundle__cart");
    this.productsWrap = document.querySelector(".tayst-bundle__grid");
    this.cloneSlot = document.querySelector(".tayst-bundle__selected-slot");
    this.min_product_required = 1;
    this.itemsSelected = [];
    this.bundle_collecton_id = "";
    this.loadWidget(this);
    this.dataEvents(this);
  }
  async loadWidget(that){
    let bundle_id = this.submitBtn.getAttribute("data-bundleId"); 
    let bundle_config = await recharge.bundleData.loadBundleData(bundle_id);
    let products_html = '';
    Object.values(bundle_config.collections).forEach(collection => {
      that.bundle_collecton_id = collection.id;
      document.querySelector(".tayst-bundle__products-head-main").textContent = collection.title;
      collection.products.forEach(product => {
        const variant = product.variants[0];
        let productTypes = ["Pods For Keurig","Ground Coffee","Whole Beans","Capsules for Nespresso"];
        let title_pattern = new RegExp(`\\s*(${productTypes.map(type => type.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|")})$`,"i");
        let prod_title = product.title.replace(title_pattern, (_, type) =>`<br/><small>${type.toLowerCase()}</small>`);
        products_html += `
        <div class="tayst-bundle-card" data-product-id="${product.id}"
          data-variant-id="${variant.id}" data-product-title="${product.title}"
          data-product-price="${variant.selling_plan_allocations[0].price}" 
          data-product-compare-price="${variant.selling_plan_allocations[0].compare_at_price}" 
          data-product-image="${product.featured_image || ''}"
          data-selling="${variant.selling_plan_allocations[0]?.selling_plan?.id}">
          <div class="tayst-bundle-card__image">
            ${product.featured_image ? `
            <img src="${product.featured_image}" class="${product.images[1] ?`tayst-bundle-card__image-one`:''}" loading="lazy" width="700" alt="${product.title}">` : ''}
            ${product.images[1] ? `<img src="${product.images[1]}" class="tayst-bundle-card__image-two" loading="lazy" width="700" alt="${product.title}">`:''}
            <button type="button" class="tayst-bundle-card__info" aria-label="More information">i</button>
            <div class="hidden">
              <div class="tayst-bundle-card__info-content">
                ${product.images[1] ? `<img src="${product.images[1]}" class="" loading="lazy" width="700" alt="${product.title}">`:''}
                <div><h3 class="h4">${product.title}</h3>${product.description}</div>
              </div>
            </div>
          </div>
          <div class="tayst-bundle-card__body">
            <h3 class="h6 tayst-bundle-card__title"><span>${prod_title}</span></h3>
            <div class="tayst-bundle-card__price active">
            <span class="tayst-bundle-card__price-compare">${wetheme.formatMoney(variant.selling_plan_allocations[0].compare_at_price)}</span>
            <strong class="tayst-bundle-card__price-actual">${wetheme.formatMoney(variant.selling_plan_allocations[0].price)}</strong>
            </div>
            <button type="button" class="tayst-bundle-card__add btn"
              ${variant.available_for_sale ? '' : 'disabled'}>
              ${variant.available_for_sale ? 'Add' : 'Sold out'}
            </button>
              <div class="tayst-bundle-card__quantity hide">
                <button type="button" class="tayst-bundle-card__minus">−</button>
                <input type="text" value="0" min="0" readonly>
                <button type="button" class="tayst-bundle-card__plus">+</button>
              </div>
          </div>
        </div>`;
      });
    });
    this.productsWrap.innerHTML = products_html;
    that.dashContentHeight();
    that.min_product_required = bundle_config.variants[0]?.ranges[0]?.min;
    document.querySelector(".tayst-bundle__cart").removeAttribute("disabled");
  }
  dataEvents(that){
    document.addEventListener("click", function(e) {
      if (e.target.closest(".tayst-bundle-card__info")) {
        e.preventDefault();
        let btn_par = e.target.closest(".tayst-bundle-card");
        let modal_cont = btn_par.querySelector(".tayst-bundle-card__info-content").outerHTML;
        const themeModal = document.querySelector('theme-modal');
        const themeModalContent = themeModal.querySelector('template[data-theme-modal-content]');
        const modal_fragment = themeModalContent.content; // DocumentFragment
        const popup = modal_fragment.querySelector('.modal-content').innerHTML = modal_cont;
        document.querySelector(".page-popup-trigger").click();
      }
      if (e.target.closest(".tayst-bundle-card__add")) {
        let addBtn = e.target.closest('.tayst-bundle-card__add');
        let card = addBtn.closest('.tayst-bundle-card');
        if (addBtn) {
          let quantityBox = card.querySelector('.tayst-bundle-card__quantity');
          let input = quantityBox.querySelector('input');
          input.value = 1;
          addBtn.classList.add("hide");
          quantityBox.classList.remove("hide");
          that.updateBundleData(that,card,input.value);
        }
      }
      if(e.target.closest(".tayst-bundle-card__quantity button")){
        let minusBtn = e.target.closest('.tayst-bundle-card__minus');
        let plusBtn = e.target.closest('.tayst-bundle-card__plus');
        let card = e.target.closest(".tayst-bundle-card");
        let input = card.querySelector('.tayst-bundle-card__quantity input');
        if (plusBtn) {
          input.value = Number(input.value) + 1;
        }
        if (minusBtn) {
          let quantityBox = card.querySelector('.tayst-bundle-card__quantity');
          let quantity = Number(input.value) - 1;
          if (quantity <= 0) {
            input.value = 0;
            quantityBox.classList.add("hide");
            card.querySelector('.tayst-bundle-card__add').classList.remove("hide");
          } else {
            input.value = quantity;
          }
        }
        that.updateBundleData(that,card,input.value);
      }
      if(e.target.closest(".tayst-bundle__slot-remove")){
        let curr_parent = e.target.closest(".tayst-bundle__selected-slot");
        let variantId = curr_parent.getAttribute("data-vid");
        let target_card = document.querySelector(`.tayst-bundle__products .tayst-bundle-card[data-variant-id="${variantId}"]`);
        if(target_card){
          let card_qty = target_card.querySelector(".tayst-bundle-card__quantity");
          card_qty.querySelector("input").value = 0;
          card_qty.querySelector(".tayst-bundle-card__minus").click();
        }
      }
      if(e.target.closest(".tayst-bundle__cart")){
        let current_btn = e.target.closest(".tayst-bundle__cart");
        let bundle_vid = current_btn.getAttribute("data-vid");
        let freeSubscriptionProdId = current_btn.getAttribute("data-free-subscription-product-id");
        let bundle_handle = current_btn.getAttribute("data-handle");
        let order_type = document.querySelector("select[data-bundle-frequency]").value;
        let item_count = 0;
        let itemsToAdd = [];
        let random_num = that.generateRandomCode();
        let cart_has_subscr_item = false;
        that.itemsSelected.forEach(function(e,i){
          let bundle_id_encode = ""+random_num+":"+bundle_vid+"";
          let sell_plan = e.selling_plan;
          item_count = item_count + parseInt(e.quantity);
          if(order_type != "subscription"){
            sell_plan = "";
          }else{
            cart_has_subscr_item = true;
          }
          let blend_item = {
            id:e.variantId,
            quantity:e.quantity,
            selling_plan:sell_plan,
            properties:{
              "_rc_bundle": bundle_id_encode,
              "_rc_bundle_parent":bundle_handle,
              "_rc_bundle_variant":bundle_vid,
              "_rc_bundle_collection_id":that.bundle_collecton_id
            }
          }
          itemsToAdd.push(blend_item);
        });
        if(item_count >= that.min_product_required){
          current_btn.setAttribute('loading',true);
          current_btn.setAttribute('disabled',true);
          fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            let cart_has_free_item = false;
            cart.items.forEach(item => {
              if(item.variant_id == freeSubscriptionProdId){
                cart_has_free_item = true;
              }
              if(item.selling_plan_allocation){
                cart_has_subscr_item = true;
              }
            });
            if(!cart_has_free_item && cart_has_subscr_item){
              let blend_item = {
                id:freeSubscriptionProdId,
                quantity:"1"
              }
              itemsToAdd.push(blend_item);
              // const discountResponse = fetch(
              //   `/discount/${encodeURIComponent(tayst.subscrCouponCode)}?redirect=/cart`,
              //   {
              //     method: 'GET',
              //     credentials: 'same-origin',
              //     redirect: 'manual'
              //   }
              // );
            }
            fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: itemsToAdd,sections: ['cart-drawer'] }),
            })
            .then(response => response.json())
            .then(response => {
              window.eventBus.emit('update:cart:drawer', response);
              // window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
              location.href = `/checkout?discount=${encodeURIComponent(tayst.subscrCouponCode)}`;
              current_btn.setAttribute('loading',false);
              current_btn.removeAttribute('disabled');
            })
            .catch(error => {
              current_btn.setAttribute('loading',false);
              current_btn.removeAttribute('disabled');
              alert('Error:', error);
            });
          });
        }else{
          document.querySelector(".tayst-bundle__cart-note").scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          document.querySelector(".tayst-bundle__cart-note").classList.add("error");
          setTimeout(function(){
            document.querySelector(".tayst-bundle__cart-note").classList.remove("error");
          },3000);
        }
      }
    });
    document.addEventListener("change",function(e){
      if(e.target.closest("select[data-bundle-frequency]")){
        let sel_value = e.target.value;
        if(sel_value != "subscription"){
          document.querySelectorAll(".tayst-bundle-card").forEach(function(e,i){
            e.querySelector(".tayst-bundle-card__price").classList.remove("active");
          });
        }else{
          document.querySelectorAll(".tayst-bundle-card").forEach(function(e,i){
            e.querySelector(".tayst-bundle-card__price").classList.add("active");
          });
        }
        let first_input = document.querySelectorAll(".tayst-bundle-card__quantity")[0];
        if(first_input){
          let input_qty = first_input.querySelector("input");
          input_qty.value = parseInt(input_qty.value) + 1;
          first_input.querySelector(".tayst-bundle-card__minus").click();
        }
      }
    });
    window.addEventListener('resize', function() {
      that.dashContentHeight();
    });
  }
  updateBundleData(that,card,quantity){
    let item_found = false;
    let items_avail = that.itemsSelected;
    if(that.itemsSelected.length > 0){
      for(let i=0;i<that.itemsSelected.length;i++){
        let item_id = that.itemsSelected[i].variantId;
        if(item_id == card.getAttribute("data-variant-id")){
          item_found = true;
          if(quantity > 0){
            items_avail[i].quantity = quantity;
          }else{
            items_avail.splice(i, 1);
          }
        }
      }
    }
    if(items_avail.length <= 0 || !item_found){
      if(quantity > 0){
        items_avail.push({
          variantId: card.getAttribute("data-variant-id"),
          title: card.getAttribute("data-product-title"),
          quantity: quantity,
          price: card.getAttribute("data-product-price"),
          comparePrice: card.getAttribute("data-product-compare-price"),
          image: card.getAttribute("data-product-image"),
          selling_plan: card.getAttribute("data-selling")
        });
      }
    }
    that.updatePageCart(that,items_avail);
  }
  updatePageCart(that,data){
    let all_slots = document.querySelectorAll(".tayst-bundle__selected-slot");
    all_slots.forEach(function(item,i){
      item.innerHTML = "";
      item.classList.remove("has-product");
      if(item.classList.contains("clone-slot")){
        item.remove();
      }
    });
    let total_count = 0;
    let price_subtotal = 0;
    let price_total = 0;
    let bundle_discount = 0;
    let free_item_val = 0;
    let free_item_par = document.querySelector(".tayst-bundle-summary-free-item-value");
    let freq_drop = document.querySelector("select[data-bundle-frequency]");
    data.forEach(function(item, i) {
      if(i>=all_slots.length){
        let slotCopy = that.cloneSlot.cloneNode(true);
        slotCopy.classList.add("clone-slot");
        slotCopy.setAttribute("data-slot",i+1);
        document.querySelector(".tayst-bundle__selected").appendChild(slotCopy);
      }

      let active_price = "";
      let actual_price = item.comparePrice * 1;
      let discount_value = document.querySelector(".tayst-bundle__cart").getAttribute("data-discount");
      
      price_subtotal = price_subtotal + (actual_price * parseInt(item.quantity));
      
      if(freq_drop.value == "subscription"){
        active_price = " active";
        actual_price = item.price;
        if(discount_value != ""){
          discount_value = parseInt(discount_value);
          bundle_discount = price_subtotal * discount_value / 100;
        }
      }
      
      price_total = price_total + (actual_price * parseInt(item.quantity));

      total_count = total_count + parseInt(item.quantity);
      all_slots = document.querySelectorAll(".tayst-bundle__selected-slot");
      let curr_slot = all_slots[i];
      curr_slot.innerHTML = '';
      curr_slot.classList.add('has-product');
      curr_slot.setAttribute("data-vid",item.variantId)
      curr_slot.innerHTML =
      '<img src="' + (item.image || '') + '" alt="" loading="lazy">' +
      '<span class="tayst-bundle__slot-info '+active_price+'"><strong>' + item.title + '</strong><small class="tayst-bundle__slot-compare-price">' + wetheme.formatMoney(item.comparePrice) 
      +'</small><small class="tayst-bundle__slot-actual-price">' + wetheme.formatMoney(item.price) 
      +'</small><small class="tayst-bundle__slot-quantity">&times;&nbsp;' + item.quantity +'</small></span>' +
      '<button type="button" class="tayst-bundle__slot-remove" aria-label="Remove ' + item.title.replace(/"/g, '&quot;') + '" data-remove-index="' + i + '">×</button>';
    });
    if(free_item_par && price_total > 0 && freq_drop.value == "subscription"){
      free_item_val = free_item_par.getAttribute("data-value") * 1;
      price_subtotal = price_subtotal + free_item_val;
    }
    document.querySelector(".tayst-bundle__summary-title span[data-selected-count]").textContent = total_count;
    document.querySelector(".tayst-bundle-summary-subtotal-value").innerHTML = wetheme.formatMoney(price_subtotal);
    document.querySelector(".tayst-bundle-summary-amount-saving").innerHTML = "&minus;" + wetheme.formatMoney(bundle_discount);
    document.querySelector(".tayst-bundle-summary-free-item-value").innerHTML = "&minus;" + wetheme.formatMoney(free_item_val);
    document.querySelector(".tayst-bundle-summary-total-value").innerHTML = wetheme.formatMoney(price_total);
  }
  dashContentHeight() {
    document.querySelectorAll(".tayst-bundle__products .tayst-bundle__grid").forEach(wrap => {
      const itemTitle = wrap.querySelectorAll(".tayst-bundle-card__title");
      const itemTitleChild = wrap.querySelectorAll(".tayst-bundle-card__title span");
      itemTitle.forEach(item => {
        item.style.height = "unset";
      });
      if (window.innerWidth > 359) {
        window.miniHeight(itemTitle, itemTitleChild);
      }
    });
  }
  generateRandomCode() {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < 9; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      code += chars[randomIndex];
    }
    return code;
  }
}
window.addEventListener("load", () => {
  new TaystBundleWidget();
});